export default __webpack_public_path__ + "static/media/oub1.26f6e1e5.jpeg";